import styled from 'styled-components';
import ObligationFormQuestionHelp from '../ObligationFormQuestionHelp';

export default function QuestionType3(props) {
  const { question } = props;

  return (
    <QuestionGroup>
      <PlainText>{question.name}</PlainText>
      <ObligationFormQuestionHelp question={question} />
    </QuestionGroup>
  );
}
const QuestionGroup = styled.div`
  display: grid;
  grid-template-columns: 1fr 30px;
`;
const PlainText = styled.div`
  white-space: pre-wrap;
`;